import { render, staticRenderFns } from "./CityGeofenceReport.vue?vue&type=template&id=2cb35906&"
import script from "./CityGeofenceReport.vue?vue&type=script&lang=js&"
export * from "./CityGeofenceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports